import appEvents from 'events/app';
import configSelectors from 'selectors/configuration';
import showWidget from 'actions/ui/showWidget';
import unminimizeWidget, { WIDGET_OPENED_TRIGGER_PROACTIVE_RULE } from 'actions/ui/unminimizeWidget';

export default function openProactive(dispatch, getState) {
  const currentRule = getState().app.currentRule;
  const key = currentRule.key;
  const rule = currentRule.rule;

  if (configSelectors.isActiveRule(key, rule)) {
    dispatch(unminimizeWidget(WIDGET_OPENED_TRIGGER_PROACTIVE_RULE));
    dispatch(showWidget);
    dispatch(appEvents.proactiveTriggered());
  }
}
